import { Injectable } from '@angular/core';
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMetaDataGridActionState, DwOrmDataService, DwOrmDataServiceToken, ensureArray } from '@devwareapps/devware-cap';
import { Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChallengeTeamJoinRequestEntity, ChallengeTeamJoinRequestStatusAllItems } from '../../../meta-data/app-meta-data.service';

@DwAction({
    keyName: 'approve-join-request',
    display: 'Approve Request',
    actionType: DwActionType.menuAction,
    isGlobal: true,
    allowOnce: true,
    configData: {
        requireValidation: false,
        redirectAfter: false,
        actionMessage: '',
    }
})
@Injectable()
export class ApproveJoinRequestActionService implements DwActionHandler {


    constructor(
        @Inject(DwOrmDataServiceToken) private ormDataService: DwOrmDataService,
    ) {}

    handleAction(actionState: DwMetaDataGridActionState<ChallengeTeamJoinRequestEntity>): Observable<DwActionResult> {
        const result = new DwActionResult();
        const joinRequest = ensureArray(actionState?.data)[0];

        if (!joinRequest) {
            result.success = false;
            result.cancelled = true;
            return of(result);
        }

        const updatedRequest = { ...joinRequest, ChallengeTeamJoinRequestStatusId: ChallengeTeamJoinRequestStatusAllItems.Approved };

        return this.ormDataService.saveEntity(updatedRequest).pipe(
            map(() => {
                result.success = true;
                return result;
            })
        );
    }
}
